import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from './assets/logo-1657285507.jpg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        color: "surface",
        elevation: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
          }),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_0,
                height: "40px",
                style: {"padding-top":"6px"}
              }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawer) = $event)),
        app: ""
      }, {
        append: _withCtx(() => [
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list, { class: "pt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": _ctx.aboutView.icon,
                title: _ctx.aboutView.title,
                to: _ctx.aboutView.path,
                link: "",
                color: "primary",
                style: {"cursor":"pointer"}
              }, null, 8, ["prepend-icon", "title", "to"]),
              (_ctx.statusLoggedIn)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    class: "mt-2 text-error",
                    "prepend-icon": "mdi-logout",
                    title: "Logout",
                    onClick: _ctx.logout,
                    style: {"cursor":"pointer"}
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, { class: "pt-4" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainViews, (view) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: view.path,
                  "prepend-icon": view.icon,
                  title: view.title,
                  to: view.path,
                  link: "",
                  color: "primary",
                  style: {"cursor":"pointer"}
                }, null, 8, ["prepend-icon", "title", "to"]))
              }), 128)),
              _createVNode(_component_v_list_group, { value: "sales" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    "prepend-icon": "mdi-cash-register",
                    title: "Sales",
                    color: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/sales/dashboard')))
                  }), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    title: "Dashboard",
                    to: "/sales/dashboard",
                    link: "",
                    color: "primary",
                    style: {"cursor":"pointer"}
                  }),
                  _createVNode(_component_v_list_item, {
                    title: "Import and Review",
                    to: "/sales/import-and-review",
                    link: "",
                    color: "primary",
                    style: {"cursor":"pointer"}
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": _ctx.settingsView.icon,
                title: _ctx.settingsView.title,
                to: _ctx.settingsView.path,
                link: "",
                color: "primary",
                style: {"cursor":"pointer"}
              }, null, 8, ["prepend-icon", "title", "to"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        app: "",
        color: "secondary",
        elevation: "2"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("© Tjoef Tjaf 2022")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}